import {writable} from "../../_snowpack/pkg/svelte/store.js";
export const loading = writable(false);
//# sourceMappingURL=index.js.map
